import { CommonResponseModel, vehiclecategoryActivateDeactivateDto, vehiclemodelActivateDeactivateDto } from "@project-management-system/shared-models";
import { CommonAxiosService } from "packages/libs/shared-services/src/common-axios-service-prs";


export class VehicleModelService extends CommonAxiosService {
    private VehicleController = "/vehicle_model";

    async createVehicleModel(req: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VehicleController + "/createVehicleModel", req)
    }

    async getAllVehicleModel(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VehicleController + "/getAllVehicleModel")
    }

    async getAllVehicleModelByCategory(req: any): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VehicleController + "/getAllVehicleModelByCategory", req)
    }

    async updateVehiclemodel(dto: any): Promise<CommonResponseModel> {
        return await this.axiosPostCall(this.VehicleController + '/updateVehicleModel', dto)
    }

    async activateOrDeactivateVehicleModel(req?: vehiclemodelActivateDeactivateDto): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.VehicleController + "/activateOrDeactivateVehicleModel", req)
    }

    // async getActiveAllVehicleCategory(): Promise<CommonResponseModel> {
    //     return this.axiosPostCall(this.VehicleController + "/getActiveAllVehicleCategory")
    // }
    // async updateVehicleCatgeory(dto: any): Promise<CommonResponseModel> {
    //     return await this.axiosPostCall(this.VehicleController + '/updateVehicleCatgeory', dto)
    // }

    // async activateOrDeactivateVehicleCategory(req?:vehiclecategoryActivateDeactivateDto): Promise<CommonResponseModel> {
    //     return this.axiosPostCall(this.VehicleController + "/activateOrDeactivateVehicleCategory", req)
    // }

}